
// import React, { useEffect, useState } from 'react'
// import { Link, useLocation, useNavigate } from 'react-router-dom'
// import Breadcrumb from '../../../Components/Utils/Breadcrumb'
// import { CreateButton, ExportButton, FilterButton, ClearFilterButton } from '../../../Components/Utils/Buttons'
// import SearchBar from '../../../Components/Utils/SearchBar'
// import { GetAccess } from '../../../Components/Utils/roles'

// const ContractManagementLayout = ({
//   getData = () => {},
//   setSearchQuery = () => {},
//   CreateAccess = false,
//   setOpenExport = () => {},
//   children,
//   onCreateClick,
//   searchValue = "",
//   searchFun = () => {},
//   isFilter = false,
//   setFilterOpen = () => {},
//   newfilter = false,
//   ClearFilter = () => {},
//   neededSearch = false,
//   ExportAccess = false,
//   total = "0"
// }) => {
//   const { pathname } = useLocation()
//   const [module, setModule] = useState("")
//   const navigate = useNavigate()
//   const [menuSettings, setMenuSettings] = useState([])

//   useEffect(() => {
//     const savedSettings = localStorage.getItem("contractMenuSettings")
//     if (savedSettings) {
//       setMenuSettings(JSON.parse(savedSettings))
//     }
//   }, [])

//   useEffect(() => {
//     if (pathname === `/Contract-management/survey-report`) setModule("Survey")
//     else if (pathname === `/Contract-management/equiments`) setModule("Cont. Equipt.")
//     else if (pathname === `/Contract-management/contracts`) setModule("Contract")
//     else if (pathname === `/Contract-management/renewal`) setModule("Renewal")
//     else if (pathname === `/testingAndcommisioning/schedules`) setModule("Schedules")
//     else if (pathname === `/collectionAndreturn/fireExtinguisher`) setModule("Fire Extinguisher")
//     else if (pathname === `/collectionAndreturn/fireSuppression`) setModule("Fire Suppression")
//   }, [pathname])

//   const isEnabled = (name) => {
//     const menu = menuSettings.find(m => m.name === name)
//     return menu ? menu.enabled : true
//   }

//   const handleCreateClick = () => {
//     if (module === "Cont. Equipt.") {
//       onCreateClick && onCreateClick()
//     } else {
//       navigate(`${pathname}/create`)
//     }
//   }

//   const LinkItem = [
//     { key: "survey_view", label: "Surveys", link: `/Contract-management/survey-report`, view: true },
//     { key: "contracts_view", label: "Contracts", link: `/Contract-management/contracts`, view: true },
//     { key: "", label: "Renewal", link: `/Contract-management/renewal`, view: true },
//     { key: "commissioning_schedules_view", label: "Commisioning", link: `/testingAndcommisioning/schedules`, view: isEnabled("commissioning") },
//     { key: "fire_extinguisher_view", label: "Fire Extinguisher", link: `/collectionAndreturn/fireExtinguisher`, view: isEnabled("fire_extinguisher") },
//     { key: "fire_suppression_view", label: "Fire Suppression", link: `/collectionAndreturn/fireSuppression`, view: isEnabled("fire_suppression") }
//   ]

//   return (
//     <div className="w-full h-full py-2 px-4 overflow-hidden">
//       <div className="md:flex justify-between w-full">
//         <Breadcrumb items={[{ name: "Contract-Management" }, { name: module }]} />
//         <div className="flex justify-end items-center gap-3">
//           {neededSearch && <SearchBar handleChange={searchFun} value={searchValue} />}
//           {newfilter && <>
//             <FilterButton label='Filter' handleClick={() => { setFilterOpen(true); setSearchQuery("") }} />
//             {isFilter && <ClearFilterButton label='Clear' handleClick={ClearFilter} />}
//           </>}
//           {ExportAccess && <ExportButton label="Export" handleClick={() => setOpenExport(true)} />}
//           {CreateAccess && <CreateButton handleClick={handleCreateClick} label="Add" className="create-activity-button" />}
//         </div>
//       </div>

//       <div className="w-full overflow-x-auto whitespace-nowrap scrollbar-hide md:flex gap-x-10 mt-0.5">
//         <div className="inline-flex items-center gap-x-1">
//           {LinkItem.map((item, i) => {
//             const isActive = item.link === pathname
//             return (
//               GetAccess(item.key) && item.view && (
//                 <Link
//                   to={item.link}
//                   key={item.link}
//                   className={`px-4 py-1 rounded-t-md text-xs 2xl:text-sm font-medium mt-0.5
//                     ${isActive ? "bg-baseColor-primary text-white" : "bg-white text-baseColor-primary border-b-2 border-baseColor-primary"}`}
//                 >
//                   {item.label}
//                 </Link>
//               )
//             )
//           })}
//         </div>
//         <div className="sm:mt-0 mt-1 h-auto border rounded-full mr-3 border-baseColor-primary text-xs inline-flex w-auto flex-shrink-0 justify-center overflow-hidden">
//           <p className="w-auto bg-white text-black px-2 flex items-center justify-center">Total</p>
//           <p className="bg-baseColor-primary w-auto text-white px-2 flex items-center justify-center">{total}</p>
//         </div>
//       </div>

//       <div className="w-full h-[calc(100vh-211px)] md:h-[calc(100vh-165px)]">
//         {children}
//       </div>
//     </div>
//   )
// }

// export default ContractManagementLayout


import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Breadcrumb from "../../../Components/Utils/Breadcrumb";
import {
  CreateButton,
  ExportButton,
  FilterButton,
  ClearFilterButton,
} from "../../../Components/Utils/Buttons";
import SearchBar from "../../../Components/Utils/SearchBar";
import { GetAccess } from "../../../Components/Utils/roles";
import { ContractMenuStorage } from "../../../Components/Utils/ContractLocal";

const ContractManagementLayout = ({
  getData = () => {},
  setSearchQuery = () => {},
  CreateAccess = false,
  setOpenExport = () => {},
  children,
  onCreateClick,
  searchValue = "",
  searchFun = () => {},
  isFilter = false,
  setFilterOpen = () => {},
  newfilter = false,
  ClearFilter = () => {},
  neededSearch = false,
  ExportAccess = false,
  total = "0",
}) => {
  const { pathname } = useLocation();
  const [module, setModule] = useState("");
  const navigate = useNavigate();
  const [menuSettings, setMenuSettings] = useState([]);

  useEffect(() => {
    setMenuSettings(ContractMenuStorage.get());
  }, []);

  useEffect(() => {
    if (pathname === `/Contract-management/survey-report`) setModule("Survey");
    else if (pathname === `/Contract-management/equiments`) setModule("Cont. Equipt.");
    else if (pathname === `/Contract-management/contracts`) setModule("Contract");
    else if (pathname === `/Contract-management/renewal`) setModule("Renewal");
    else if (pathname === `/testingAndcommisioning/schedules`) setModule("Schedules");
    else if (pathname === `/collectionAndreturn/fireExtinguisher`) setModule("Fire Extinguisher");
    else if (pathname === `/collectionAndreturn/fireSuppression`) setModule("Fire Suppression");
  }, [pathname]);

  const isEnabled = (name) => {
    const formattedName = name.toLowerCase().replace(/\s/g, "_");
    const menu = menuSettings.find((m) => m.name === formattedName);
    return menu ? menu.enabled : false;
  };

  const handleCreateClick = () => {
    if (module === "Cont. Equipt.") {
      onCreateClick && onCreateClick();
    } else {
      navigate(`${pathname}/create`);
    }
  };

  const LinkItem = [
    { key: "survey_view", label: "Surveys", link: `/Contract-management/survey-report`, view: true },
    { key: "contracts_view", label: "Contracts", link: `/Contract-management/contracts`, view: true },
    { key: "", label: "Renewal", link: `/Contract-management/renewal`, view: true },
    { key: "commissioning_schedules_view", label: "Commisioning", link: `/testingAndcommisioning/schedules`, view: isEnabled("commissioning") },
    { key: "fire_extinguisher_view", label: "Fire Extinguisher", link: `/collectionAndreturn/fireExtinguisher`, view: isEnabled("fireextinguister") },
    { key: "fire_suppression_view", label: "Fire Suppression", link: `/collectionAndreturn/fireSuppression`, view: isEnabled("firesuppression") },
  ];

  return (
    <div className="w-full h-full py-2 px-4">
      <div className="md:flex justify-between w-full">
        <Breadcrumb items={[{ name: "Contract-Management" }, { name: module }]} />
        <div className="flex gap-3">
          {neededSearch && <SearchBar handleChange={searchFun} value={searchValue} />}
          {newfilter && (
            <>
              <FilterButton label="Filter" handleClick={() => setFilterOpen(true)} />
              {isFilter && <ClearFilterButton label="Clear" handleClick={ClearFilter} />}
            </>
          )}
          {ExportAccess && <ExportButton label="Export" handleClick={() => setOpenExport(true)} />}
          {CreateAccess && <CreateButton handleClick={handleCreateClick} label="Add" />}
        </div>
      </div>

       <div className="w-full overflow-x-auto whitespace-nowrap scrollbar-hide md:flex gap-x-10 mt-0.5">
         <div className="inline-flex items-center gap-x-1">
         {LinkItem.map(
          (item) =>
            GetAccess(item.key) &&
            item.view && (
              <Link
                to={item.link}
                key={item.link}
                className={`px-4 py-1 rounded-t-md text-xs 2xl:text-sm font-medium mt-0.5 ${
                  item.link === pathname
                    ? "bg-baseColor-primary text-white"
                    : "bg-white text-baseColor-primary border-b-2 border-baseColor-primary"
                }`}
              >
                {item.label}
              </Link>
            )
        )}
        </div>
        <div className="sm:mt-0 mt-1 h-auto border rounded-full mr-3 border-baseColor-primary text-xs inline-flex w-auto flex-shrink-0 justify-center overflow-hidden">
          <p className="w-auto bg-white text-black px-2 flex items-center justify-center">Total</p>
          <p className="bg-baseColor-primary w-auto text-white px-2 flex items-center justify-center">{total}</p>
        </div>
      </div>

        <div className="w-full h-[calc(100vh-211px)] md:h-[calc(100vh-165px)]">
  {children}</div>
    </div>
  );
};

export default ContractManagementLayout;
